// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__WqNGv","link--active":"styles_link--active__aORxc","skeleton-animation":"styles_skeleton-animation__N_EGP"};